import { useEffect, useMemo, useState, useRef } from "react"
import { Link, useLocation, useHistory } from "react-router-dom"
import { Input, Button, Table, Select, DatePicker, Modal, message, Row, Col, Statistic, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    store_id: string | undefined,
    check_in_status: number | undefined,
    check_in_user_name: string | undefined,
    check_in_phone: number | undefined,
    preg_status: number | undefined,
    birthDate: any,
    expectBornDay: any,
    actuallyBornDay: any,
    dealDate: any,
    nursing_care_type: number | undefined,
    room_type_id: string | undefined,
    room_number: number | undefined,
    checkInDay: any,
    checkOutDay: any,
    has_continue: number | undefined,
    continue_type: number | undefined,
    belong_minion_id: string | undefined
}

type fetchParams2 = {
    user_name: string | undefined,
    phone: string | undefined,
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

interface ep {
    "employee_id": string,
    "user_name": string
}

// 数量汇总
type summaryNum = {
    all_customer?: any, // 全部客户,
    wait_distribute_customer?: any, // 待分配客户
    wait_check_in_customer?: any, // 待入住客户
    already_check_in_customer?: any, // 已入住客户
    month_check_out_customer?: any, // 本月已出所客户
    month_wait_born_customer?: any, // 本月待产客户
    need_interview_customer?: any, // 需回访客户
    leave_three_day_customer?: any, // 3天内出所客户
    leave_seven_day_customer?: any, // 一周内出所客户
    birthday_three_day_customer?: any // 3天内生日客户
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        check_in_status: undefined,
        check_in_user_name: undefined,
        check_in_phone: undefined,
        preg_status: undefined,
        birthDate: null,
        expectBornDay: null,
        actuallyBornDay: null,
        dealDate: undefined,
        nursing_care_type: undefined,
        room_type_id: undefined,
        room_number: undefined,
        checkInDay: null,
        checkOutDay: null,
        has_continue: undefined,
        continue_type: undefined,
        belong_minion_id: undefined
    }

    let fetchOtherParamsTmpl2: fetchParams2 = {
        user_name: undefined,
        phone: undefined,
    }

    let dataTotals = [
        { type: 0, url: '/keeper/check_in/base_page_list' },
        { type: 1, url: '/keeper/check_in/wait_distribute_page_list' },
        { type: 2, url: '/keeper/check_in/wait_check_in_page_list' },
        { type: 3, url: '/keeper/check_in/already_check_in_page_list' },
        { type: 4, url: '/keeper/check_in/this_month_already_check_out_page_list' },
        { type: 5, url: '/keeper/check_in/this_month_wait_born_page_list' },
        { type: 6, url: '/keeper/check_in/need_interview_page_list' },
        { type: 7, url: '/keeper/check_in/leave_in_three_day_page_list' },
        { type: 8, url: '/keeper/check_in/leave_in_seven_day_page_list' },
        { type: 9, url: '/keeper/check_in/birthday_in_three_day_page_list' }
    ]

    const History = useHistory()
    // 获取链接参数
    const Location: any = useLocation()
    // 顶部筛选按钮类型设置
    const btnCurrentType = useRef<number>((Location.state && Location.state.btnCurrentType) || 0) // 记录顶部搜索的按钮类型 

    // 数量汇总
    const [summary, setSummary] = useState<summaryNum>({
        all_customer: 0, // 全部客户,
        wait_distribute_customer: 0, // 待分配客户
        wait_check_in_customer: 0, // 待入住客户
        already_check_in_customer: 0, //已入住客户
        month_check_out_customer: 0, // 本月已出所客户
        month_wait_born_customer: 0, // 本月待产客户
        need_interview_customer: 0, // 需回访客户
        leave_three_day_customer: 0, // 3天内出所客户
        leave_seven_day_customer: 0, // 一周内出所客户
        birthday_three_day_customer: 0 // 3天内生日客户
    })

    const [gjData, setGjData] = useState<ep[]>([])
    const [roomTypeList, setRoomTypeList] = useState<{ room_type_id: string, room_type_name: string }[]>([])

    // 列表筛选条件设置
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(() => {
        // 回填链接传回的数值
        let stateFetchOtherParams = null
        if (Location.state && Location.state.fetchOtherParams) {
            const { fetchOtherParams } = Location.state

            if (fetchOtherParams.birthDate) {
                fetchOtherParams.birthDate[0] = moment(fetchOtherParams.birthDate[0])
                fetchOtherParams.birthDate[1] = moment(fetchOtherParams.birthDate[1])
            }

            if (fetchOtherParams.actuallyBornDay) {
                fetchOtherParams.actuallyBornDay[0] = moment(fetchOtherParams.actuallyBornDay[0])
                fetchOtherParams.actuallyBornDay[1] = moment(fetchOtherParams.actuallyBornDay[1])
            }

            if (fetchOtherParams.checkInDay) {
                fetchOtherParams.checkInDay[0] = moment(fetchOtherParams.checkInDay[0])
                fetchOtherParams.checkInDay[1] = moment(fetchOtherParams.checkInDay[1])
            }

            if (fetchOtherParams.checkOutDay) {
                fetchOtherParams.checkOutDay[0] = moment(fetchOtherParams.checkOutDay[0])
                fetchOtherParams.checkOutDay[1] = moment(fetchOtherParams.checkOutDay[1])
            }

            if (fetchOtherParams.expectBornDay) {
                fetchOtherParams.expectBornDay[0] = moment(fetchOtherParams.expectBornDay[0])
                fetchOtherParams.expectBornDay[1] = moment(fetchOtherParams.expectBornDay[1])
            }

            if (fetchOtherParams.dealDate) {
                fetchOtherParams.dealDate[0] = moment(fetchOtherParams.dealDate[0])
                fetchOtherParams.dealDate[1] = moment(fetchOtherParams.dealDate[1])
            }

            stateFetchOtherParams = fetchOtherParams

        } else {
            stateFetchOtherParams = fetchOtherParamsTmpl
        }

        return stateFetchOtherParams
    })

    // 列表分页
    const [pagination, setPagination] = useState<pagination>(() => {
        let statePagination = (Location.state && Location.state.pagination) ? Location.state.pagination : {
            current: 1,
            pageSize: 8,
            total: 0,
            showSizeChanger: false,
        }

        return statePagination
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    // 列表Loading
    const [loading, setLoading] = useState<boolean>(false)

    // 未入住客户信息列表筛选条件
    const [fetchOtherParams2, setFetchOtherParams2] = useState<fetchParams2>(fetchOtherParamsTmpl2)
    // 未入住客户信息列表分页
    const [pagination2, setPagination2] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 未入住客户信息列表数据
    const [data2, setData2] = useState<any>([])
    // 未入住客户信息弹窗显示设置
    const [visible, setVisible] = useState<boolean>(false)

    // 页面权限设置
    const permission: string[] = useMemo(() => {
        // console.log(getPermission())
        return getPermission()
    }, [window.location.pathname])

    // 重置筛选
    const resetForm = () => {
        let params: any = {}

        if (btnCurrentType.current != 0) {
            params = {
                ...fetchOtherParamsTmpl,
                store_id: fetchOtherParams.store_id
            }

        } else {
            params = {
                ...fetchOtherParamsTmpl,
                store_id: undefined
            }
        }

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        setFetchOtherParams(params)

        fetchSummary(params)
        fetch({ pagination: p, fetchOtherParams: params })
    }

    // 点击顶部按钮的时候重置搜索表单
    const resetSearchForm = () => {
        History.replace({
            ...Location,
            state: null
        })

        resetForm()
    }

    // 点击顶部按钮
    const handleBtnClick = (type: any) => {
        btnCurrentType.current = type
        resetSearchForm()
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams })
    }

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        iPagination.page = iPagination.current
        iPagination.size = iPagination.pageSize

        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'birthDate', ['start_birth_day', 'end_birth_day'])
        handleDate(params, 'expectBornDay', ['expect_born_start_day', 'expect_born_end_day'])
        handleDate(params, 'actuallyBornDay', ['actually_born_start_day', 'actually_born_end_day'])
        handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
        handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])
        handleDate(params, 'dealDate', ['start_deal_date', 'end_deal_date'])

        axiosTable.get(dataTotals[btnCurrentType.current].url, {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    // 获取汇总数据
    const fetchSummary = (fetchOtherParams: fetchParams) => {
        let params: any = { ...fetchOtherParams }

        handleDate(params, 'birthDate', ['start_birth_day', 'end_birth_day'])
        handleDate(params, 'expectBornDay', ['expect_born_start_day', 'expect_born_end_day'])
        handleDate(params, 'actuallyBornDay', ['actually_born_start_day', 'actually_born_end_day'])
        handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
        handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])
        handleDate(params, 'dealDate', ['start_deal_date', 'end_deal_date'])

        axiosTable.get('/keeper/check_in/summary_customer_num', {
            params
        }).then((res: any) => {
            setSummary(res)
        })
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetchSummary(fetchOtherParams)
        fetch({ pagination: p, fetchOtherParams })
    }

    // 加载全部列表数据
    useEffect(() => {
        fetchSummary(fetchOtherParams)
        fetch({ pagination, fetchOtherParams })
    }, [])

    const resetForm2 = () => {
        setFetchOtherParams2(fetchOtherParamsTmpl2)

        let p: any = { ...pagination2 }
        p.current = 1
        setPagination2(p)

        fetch2({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl2 })
    }

    // 查询未入住客户信息
    const fetch2 = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current

        let params: any = { ...fetchOtherParams }

        axiosTable.get('/keeper/check_in/not_exist_check_in_page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination2 }
                p.total = response.total

                setPagination2(p)
                setData2(response.records)
            }

            setLoading(false)
        })
    }

    // 加载未入住客户信息
    // useEffect(() => {
    //     fetch2({ pagination: pagination2, fetchOtherParams: fetchOtherParams2 })
    // }, [pagination2.current])

    const handleSearch2 = () => {
        const p = { ...pagination2 }
        p.current = 1

        fetch2({ pagination: p, fetchOtherParams: fetchOtherParams2 })
    }

    const handleTableChange2 = (antPagination: any) => {
        const p = { ...pagination2 }
        p.current = antPagination.current

        setPagination2(p)
    }

    const handleChange2 = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams2)
        params[attr] = value

        setFetchOtherParams2(params)
    }

    // 导出
    const exportExcel = () => {
        message.success('此次导出需要较长时间，请稍等..')

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        if (btnCurrentType.current === 0) {
            handleDate(params, 'birthDate', ['start_birth_day', 'end_birth_day'])
            handleDate(params, 'expectBornDay', ['expect_born_start_day', 'expect_born_end_day'])
            handleDate(params, 'actuallyBornDay', ['actually_born_start_day', 'actually_born_end_day'])
            handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
            handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])
            handleDate(params, 'dealDate', ['start_deal_date', 'end_deal_date'])

        } else {
            params = null
        }

        baseAxiosComplete('/keeper/check_in/export', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    return (<div className="common-page">
        {/* 管家中心 -> 入住管理 -> 入住客户管理 */}
        <BreadCrumb position={['管家中心', '入住客户管理']} />

        {/* 页面筛选 */}
        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                {/* 页面按钮筛选 */}
                <Row gutter={20} style={{ marginBottom: 10 }}>

                    {permission.includes('全部') && <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(0) }}
                            style={{ backgroundColor: btnCurrentType.current == 0 ? '#1890ff' : '', marginTop: 5 }}
                        >全部</Button>
                    </Col>}

                    {permission.includes('待分配客户') && <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(1) }}
                            style={{ backgroundColor: btnCurrentType.current == 1 ? '#1890ff' : '', marginTop: 5 }}
                        >待分配客户</Button>
                    </Col>}

                    {permission.includes('待入住客户') && <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(2) }}
                            style={{ backgroundColor: btnCurrentType.current == 2 ? '#1890ff' : '', marginTop: 5 }}
                        >待入住客户</Button>
                    </Col>}

                    {permission.includes('已入住客户') && <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(3) }}
                            style={{ backgroundColor: btnCurrentType.current == 3 ? '#1890ff' : '', marginTop: 5 }}
                        >已入住客户</Button>
                    </Col>}

                    {permission.includes('本月已出所客户') && <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(4) }}
                            style={{ backgroundColor: btnCurrentType.current == 4 ? '#1890ff' : '', marginTop: 5 }}
                        >本月已出所客户</Button>
                    </Col>}

                    {permission.includes('本月待产客户') && <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(5) }}
                            style={{ backgroundColor: btnCurrentType.current == 5 ? '#1890ff' : '', marginTop: 5 }}
                        >本月待产客户</Button>
                    </Col>}

                    {permission.includes('需回访客户') && <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(6) }}
                            style={{ backgroundColor: btnCurrentType.current == 6 ? '#1890ff' : '', marginTop: 5 }}
                        >需回访客户</Button>
                    </Col>}

                    {permission.includes('3天内出所客户') && <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(7) }}
                            style={{ backgroundColor: btnCurrentType.current == 7 ? '#1890ff' : '', marginTop: 5 }}
                        >3天内出所客户</Button>
                    </Col>}

                    {permission.includes('7天内出所客户') && <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(8) }}
                            style={{ backgroundColor: btnCurrentType.current == 8 ? '#1890ff' : '', marginTop: 5 }}
                        >一周内出所客户</Button>
                    </Col>}

                    {permission.includes('3天内生日客户') && <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(9) }}
                            style={{ backgroundColor: btnCurrentType.current == 9 ? '#1890ff' : '', marginTop: 5 }}
                        >3天内生日客户</Button>
                    </Col>}
                </Row>
            </Space>

            <Space direction="horizontal" wrap style={{ marginTop: 10 }}>
                <div className="fl" style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores onChange={(value: string) => {
                        handleChange(value, 'store_id')

                        baseAxiosNoInfo('/global/employee_list_by_position', {
                            params: {
                                department_id: value,
                                position_number: '26,22'
                            }

                        }).then((res: any) => {
                            res && setGjData(res)
                        })

                        if (value) {
                            // 查询房型
                            baseAxiosNoInfo('/global/room_type_list_by_store', {
                                params: {
                                    store_id: value
                                }
                            }).then((res: any) => {
                                res && setRoomTypeList(res)
                            })

                        } else {
                            setRoomTypeList([])
                        }
                    }}
                        value={fetchOtherParams.store_id}
                    />
                </div>
                {
                    (btnCurrentType.current == 0 || btnCurrentType.current == 5) ? (
                        <Select allowClear
                            className="fl"
                            virtual={false}
                            style={{ marginRight: 8, marginBottom: 12, width: 150 }}
                            placeholder="入住状态"
                            value={fetchOtherParams.check_in_status}
                            onChange={(v: number) => { handleChange(v, 'check_in_status') }}>
                            <Option value={0} key={0}>待分配</Option>
                            <Option value={1} key={1}>已预订</Option>
                            <Option value={2} key={2}>已入住</Option>
                            <Option value={3} key={3}>已出所</Option>
                            <Option value={4} key={4}>跨店转入待分配</Option>
                            <Option value={5} key={5}>跨店转出</Option>
                            <Option value={6} key={6}>客户退单</Option>
                        </Select>
                    ) : null
                }
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '140px' }} placeholder="入住人姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_user_name') }} value={fetchOtherParams.check_in_user_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '140px' }} placeholder="入住人手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_phone') }} value={fetchOtherParams.check_in_phone} />

                <RangePicker
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder={["生日开始日期", "生日结束日期"]}
                    value={fetchOtherParams.birthDate}
                    onChange={(v: any) => { handleChange(v, 'birthDate') }}
                />
                <RangePicker
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 280 }}
                    placeholder={["预产期开始日期", "预产期结束日期"]}
                    value={fetchOtherParams.expectBornDay}
                    onChange={(v: any) => { handleChange(v, 'expectBornDay') }}
                />
                <RangePicker
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 280 }}
                    placeholder={["分娩日开始日期", "分娩日结束日期"]}
                    value={fetchOtherParams.actuallyBornDay}
                    onChange={(v: any) => { handleChange(v, 'actuallyBornDay') }}
                />
                <Select allowClear className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="怀孕状态" value={fetchOtherParams.preg_status} onChange={(v: number) => { handleChange(v, 'preg_status') }}>
                    <Option value={1} key={1}>正在备孕</Option>
                    <Option value={2} key={2}>已经怀孕</Option>
                    <Option value={3} key={3}>已有宝宝</Option>
                    <Option value={4} key={4}>小月子</Option>
                    <Option value={5} key={5}>孕早期</Option>
                    <Option value={6} key={6}>孕中期</Option>
                    <Option value={7} key={7}>孕晚期</Option>
                    <Option value={8} key={8}>预产期前7天</Option>
                    <Option value={9} key={9}>已分娩</Option>
                    <Option value={10} key={10}>超出预产期</Option>
                    <Option value={0} key={0}>未知</Option>
                </Select>
                <RangePicker
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder={["签单开始日期", "签单结束日期"]}
                    value={fetchOtherParams.dealDate}
                    onChange={(v: any) => { handleChange(v, 'dealDate') }}
                />

                <Select virtual={false} className="fl" style={{ marginRight: 8, marginBottom: 12, width: 140 }} placeholder="房型" onChange={(e: string) => { handleChange(e, 'room_type_id') }} value={fetchOtherParams.room_type_id} >
                    {roomTypeList.map((el: { room_type_id: string, room_type_name: string }) => <Option key={el.room_type_id} value={el.room_type_id}>{el.room_type_name}</Option>)}
                </Select>
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '140px' }} placeholder="房号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'room_number') }} value={fetchOtherParams.room_number} />

                <RangePicker
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder={["入住开始日期", "入住结束日期"]}
                    value={fetchOtherParams.checkInDay}
                    onChange={(v: any) => { handleChange(v, 'checkInDay') }}
                />
                <RangePicker
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder={["出所开始日期", "出所结束日期"]}
                    value={fetchOtherParams.checkOutDay}
                    onChange={(v: any) => { handleChange(v, 'checkOutDay') }}
                />

                <Select allowClear className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="续住类型" value={fetchOtherParams.continue_type} onChange={(v: number) => { handleChange(v, 'continue_type') }}>
                    <Option value={0} key={0}>全部</Option>
                    <Option value={1} key={1}>自费续住</Option>
                    <Option value={2} key={2}>客诉续住</Option>
                    <Option value={3} key={3}>赠送续住</Option>
                </Select>
                <Select allowClear className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: '190px' }} placeholder="责任管家（先选门店）" onChange={(e: string) => { handleChange(e, 'belong_minion_id') }} value={fetchOtherParams.belong_minion_id}>
                    {gjData.map((el: ep) => <Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                </Select>
                <Select allowClear className="fl" virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 120 }}
                    placeholder="护理模式" value={fetchOtherParams.nursing_care_type}
                    onChange={(v: number) => { handleChange(v, 'nursing_care_type') }}>
                    <Option value={0} key={0}>未知</Option>
                    <Option value={1} key={1}>一对一</Option>
                    <Option value={2} key={2}>托管</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {
                    permission.includes('查询') &&
                    <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                }
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {
                    permission.includes('导出') && (btnCurrentType.current == 0) &&
                    (<Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed">导出</Button>)
                }

                {/* { btnCurrentType.current == 0 && (<Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { setVisible(true) }} type="dashed">查询未入住客户信息</Button>)} */}
            </div>
        </div>

        {/* 表格展示 */}
        <div className="common-main" style={{ marginTop: '10px' }}>
            {/* 页面汇总数据 */}
            <Row gutter={24} style={{ marginBottom: 20, marginLeft: 0 }}>
                <Col span={2.5} style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: 5 }}>
                    <Statistic
                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>全部客户</div>}
                        value={summary ? summary.all_customer : 0} />
                </Col>
                <Col span={2.5} style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: 5 }}>
                    <Statistic
                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>待分配客户</div>}
                        value={summary ? summary.wait_distribute_customer : 0} />
                </Col>
                <Col span={2.5} style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: 5 }}>
                    <Statistic
                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>待入住客户</div>}
                        value={summary ? summary.wait_check_in_customer : 0} />
                </Col>
                <Col span={2.5} style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: 5 }}>
                    <Statistic
                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>已入住客户</div>}
                        value={summary ? summary.already_check_in_customer : 0} />
                </Col>
                <Col span={2.5} style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: 5 }}>
                    <Statistic
                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>本月已出所客户</div>}
                        value={summary ? summary.month_check_out_customer : 0} />
                </Col>
                <Col span={2.5} style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: 5 }}>
                    <Statistic
                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>本月待产客户</div>}
                        value={summary ? summary.month_wait_born_customer : 0} />
                </Col>
                <Col span={2.5} style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: 5 }}>
                    <Statistic
                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>需回访客户</div>}
                        value={summary ? summary.need_interview_customer : 0} />
                </Col>
                <Col span={2.5} style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: 5 }}>
                    <Statistic
                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>3天内出所客户</div>}
                        value={summary ? summary.leave_three_day_customer : 0} />
                </Col>
                <Col span={2.5} style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: 5 }}>
                    <Statistic
                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>一周内出所客户</div>}
                        value={summary ? summary.leave_seven_day_customer : 0} />
                </Col>
                <Col span={2.5} style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: 5 }}>
                    <Statistic
                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>3天内生日客户</div>}
                        value={summary ? summary.birthday_three_day_customer : 0} />
                </Col>
            </Row>

            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey={(records) => records.id} pagination={pagination} onChange={handleTableChange}>
                <Column fixed title="操作" render={(row: any) => {
                    return permission.includes('查看详情') ? <Link to={(location) => {
                        let params = _.cloneDeep(fetchOtherParams)

                        if (params.birthDate) {
                            params.birthDate[0] = params.birthDate[0].format('YYYY-MM-DD')
                            params.birthDate[1] = params.birthDate[1].format('YYYY-MM-DD')
                        }

                        if (params.actuallyBornDay) {
                            params.actuallyBornDay[0] = params.actuallyBornDay[0].format('YYYY-MM-DD')
                            params.actuallyBornDay[1] = params.actuallyBornDay[1].format('YYYY-MM-DD')
                        }

                        if (params.checkInDay) {
                            params.checkInDay[0] = params.checkInDay[0].format('YYYY-MM-DD')
                            params.checkInDay[1] = params.checkInDay[1].format('YYYY-MM-DD')
                        }

                        if (params.checkOutDay) {
                            params.checkOutDay[0] = params.checkOutDay[0].format('YYYY-MM-DD')
                            params.checkOutDay[1] = params.checkOutDay[1].format('YYYY-MM-DD')
                        }

                        if (params.expectBornDay) {
                            params.expectBornDay[0] = params.expectBornDay[0].format('YYYY-MM-DD')
                            params.expectBornDay[1] = params.expectBornDay[1].format('YYYY-MM-DD')
                        }

                        if (params.dealDate) {
                            params.dealDate[0] = params.dealDate[0].format('YYYY-MM-DD')
                            params.dealDate[1] = params.dealDate[1].format('YYYY-MM-DD')
                        }

                        return {
                            ...location,
                            pathname: '/check_in_detail/' + row.id,
                            state: {
                                pagination: { ...pagination },
                                fetchOtherParams: { ...params },
                                btnCurrentType: btnCurrentType.current,
                                check_in_store_id: row.check_in_store_id
                            }
                        }
                    }} >查看详情</Link> : null
                }} />
                <Column fixed title="入住状态" dataIndex="check_in_status_desc" key="check_in_status_desc" />
                <Column fixed title="入住信息" dataIndex="room_number" key="room_number" />
                <Column fixed title="客户姓名" dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column fixed title="客户手机号" dataIndex="check_in_phone" key="check_in_phone" />
                <Column fixed title="签单日期" dataIndex="deal_date" key="deal_date" />
                <Column title="客户生日" dataIndex="check_in_birthday" key="check_in_birthday" />
                <Column title="护理模式" dataIndex="nursing_care_type" key="nursing_care_type" render={(row: any) => {
                    if (row == 0) {
                        return '未知'

                    } else if (row == 1) {
                        return '一对一'

                    } else {
                        return '托管'
                    }
                }} />
                <Column title="医院陪护天数" dataIndex="hospital_escort_days" key="hospital_escort_days" />
                <Column title="怀孕时期" dataIndex="preg_status_desc" key="preg_status_desc" />
                <Column title="预产期" dataIndex="expect_born_day" key="expect_born_day" />
                <Column title="分娩日" dataIndex="actually_born_day" key="actually_born_day" />
                <Column title="入住门店" dataIndex="check_in_store_name" key="check_in_store_name" />
                <Column title="预住天数" dataIndex="check_in_total_days" key="check_in_total_days" />
                <Column title="已住天数" dataIndex="check_in_already_days" key="check_in_already_days" />
                <Column title="剩余天数" dataIndex="check_in_left_days" key="check_in_left_days" />
                <Column title="是否续住" dataIndex="has_continue" key="has_continue" render={(v: number) => v === 0 ? '否' : '是'} />
                <Column title="续住天数" dataIndex="continue_total_days" key="continue_total_days" />
                <Column title="入住时间" dataIndex="check_in_time" key="check_in_time" />
                <Column title="出所日期" dataIndex="check_out_time" key="check_out_time" />
                <Column title="责任管家" dataIndex="belong_minion_name" key="belong_minion_name" />

                <Column title="合同总金额" dataIndex="agreement_amount" />
                <Column title="已付金额" dataIndex="total_pay_amount" key="total_pay_amount" />
                <Column title="剩余尾款" dataIndex="left_pay_amount" key="left_pay_amount" />
                <Column title="其他消费总额" dataIndex="check_in_pay_other_amount" key="check_in_pay_other_amount" />
                <Column title="已交押金" dataIndex="alreay_pay_deposit" key="alreay_pay_deposit" />
                <Column title="剩余押金" dataIndex="left_deposit" key="left_deposit" />
                <Column title="客户住址" dataIndex="family_address" key="family_address" />
            </Table>
        </div>

        {/* 导入未有入住客户资料 */}
        <Modal visible={visible} title="查询未入住客户信息" width={1100} footer={null} onCancel={() => { setVisible(false) }}>
            <div style={{ marginBottom: '20px' }}>
                <Space>
                    <Input placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleChange2(e.target.value, 'user_name') }} value={fetchOtherParams2.user_name} />
                    <Input placeholder="客户手机号" onChange={(e: { target: { value: string } }) => { handleChange2(e.target.value, 'phone') }} value={fetchOtherParams2.phone} />

                    <Button icon={<SearchOutlined />} onClick={handleSearch2}>查询</Button>
                    <Button icon={<RedoOutlined />} onClick={resetForm2}>重置</Button>
                </Space>
            </div>

            <Table dataSource={data2} bordered={true} pagination={pagination2} onChange={handleTableChange2}   >
                <Column fixed title="客户姓名" dataIndex="user_name" key="user_name" />
                <Column fixed title="手机号码" dataIndex="phone" key="phone" />
                <Column fixed title="其他联系方式" dataIndex="contact_way" key="contact_way" />
                <Column fixed title="签单日期" dataIndex="deal_date" key="deal_date" />
                <Column fixed title="签单门店" dataIndex="deal_store_name" key="deal_store_name" />
                <Column fixed title="签单套餐" dataIndex="deal_item_name" key="deal_item_name" />
                <Column fixed title="签单销售" dataIndex="deal_sales_name" key="deal_sales_name" />
                <Column fixed title="合同金额" dataIndex="agreement_amount" key="agreement_amount" />

                <Column width="100px" title="操作" render={(v: any) => {
                    return <Button onClick={() => {
                        baseAxiosComplete.post('/keeper/check_in/not_exist_check_in_import', {
                            id: v.id
                        }).then(res => {
                            if (res.status == 0) {
                                fetch2({ pagination: pagination2, fetchOtherParams: fetchOtherParams2 })
                            }
                        })
                    }}>新增</Button>
                }} />
            </Table>
        </Modal>
    </div>)
}